import { Component, OnInit, Inject } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { AlgoStrategy } from '@app/_shared/providers';
import { SAVE_ONLY_DEPLOY } from '@app/_shared/modules/strategy-form/strategy.enums';
import { RouteMap } from '@app/_shared/shared.structs';
import { Router } from '@angular/router';

@Component({
  selector: 'app-confirmation-success-dialog',
  templateUrl: './confirmation-success-dialog.component.html',
  styleUrls: ['./confirmation-success-dialog.component.scss']
})
export class ConfirmationSuccessDialogComponent implements OnInit {

  RouteMap = RouteMap;
  constructor(
    @Inject(MAT_DIALOG_DATA) public strategy: {
      strategy: AlgoStrategy, 
      runningType: number, 
      algoName: string,
      update: boolean
    },
    private router: Router,
    private dialogRef: MatDialogRef<ConfirmationSuccessDialogComponent>
  ) {
  }

  ngOnInit(): void {
  }

  routeTo(route: RouteMap) {
    switch(route) {
      case RouteMap.books: 
        this.router.navigate([RouteMap.books], {queryParams: {booksTab: 2}});
        break;
      case RouteMap.dashboard:
        this.router.navigateByUrl(RouteMap.dashboard);
        break;
    }
    this.dialogRef.close(route);
  }

  get isSaveOnly() {
      return this.strategy.runningType === SAVE_ONLY_DEPLOY;
  }
}
